import type { Deck } from '@/framework/types';
import { slides } from './slides';

const deck: Deck = {
  slug: 'component-gallery',
  category: 'product-demos',
  title: 'Component Gallery',
  speaker: 'StreamNative Decks',
  description: 'Living reference for the framework chart + table primitives.',
  date: '2026-06-04',
  context: 'Internal · framework reference',
  footnote: 'PROPRIETARY & CONFIDENTIAL',
  visibility: 'public',
  slides,
};

export default deck;
